import useSWR from 'swr';
import { useSnackbar } from 'notistack';
import { useContext } from 'react';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import { ScoringContext } from '@/contexts/scoring/context';
import {
  fetchFromMTService,
  SERVICE_ENDPOINT,
} from '../fetcher/monitoringToolService';
import { ApiError } from '../ApiError';
import { HTTP_STATUS_CODE } from '../constants';
import type { SupervisorRating } from '../types';

export const useSupervisorEvaluation = () => {
  const token = useAuthToken();
  const {
    state: { collectionId },
  } = useContext(ScoringContext);

  const { enqueueSnackbar } = useSnackbar();
  const { data, error, mutate } = useSWR<SupervisorRating[], ApiError>(
    token && collectionId
      ? {
          token,
          endpoint:
            SERVICE_ENDPOINT.Collections(collectionId).supervisorRate.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (
          e.status !== HTTP_STATUS_CODE.NOT_FOUND &&
          e.status !== HTTP_STATUS_CODE.UNAUTHORIZED
        ) {
          return enqueueSnackbar(e.title, { variant: 'error' });
        }
        if (e.status === HTTP_STATUS_CODE.NOT_FOUND) return;
        if (e.status === HTTP_STATUS_CODE.UNAUTHORIZED) return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    supervisorRating: data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};
